/* eslint-disable no-undef */
const EventBus = window.EventBus;
export const Search = {
  props: ['initialinventory', 'lang'],
  data(){
    return {
      conditionItems: [],
      conditionItemsSelected: [],
      conditionshow: false,
      yearshow: false,
      makeshow: false,
      modelshow: false,
      conditionPivot: false,
      yearPivot: false,
      makePivot: false,
      modelPivot: false,
      yearItems: [],
      yearItemsSelected: [],
      makeItems: [],
      makeItemsSelected: [],
      modelItems: [],
      modelItemsSelected: [],
      inventory: [],
      pivot: null,
      searchData: {
        conditions: [],
        years: [],
        makes: [],
        models: [],
        count: 0,
      },
      firstSearchData: null,
      urlToGo: '',
      filteringOptions: {
        filter: true,
        flags: "none",
        layout: "normal",
        limit: "0",
        make: "all",
        mileage: "all",
        model: "all",
        price: "all",
        sort_by: "year",
        sort_by_condition: "desc",
        status: "all",
        stock: "all",
        tags: "all",
        trim: "all",
        type: "all",
        year: "all",
        component: "quicksearch",
        location: "all",
      }
    }
  },
  created: function () {
    this.httpRequestInventory();
},
  methods: {
    httpRequestInventory() {
      EventBus.httpRequestInventory(null, this.entryPoint, this.filteringOptions);
  },
  entryPoint(inventory) {
    this.inventory = inventory;
    this.filteredInventory = inventory;
    this.load();
},
    buildUrl(){
      let url = '';
      if(this.conditionItemsSelected.length > 0)
        url += '/condition/' + this.conditionItemsSelected.map((item) => {return item.replace(/ /g, '-').toLowerCase()}).join(',');
      if(this.yearItemsSelected.length > 0)
        url += '/year/' + this.yearItemsSelected.map((item) => {return item.replace(/ /g, '-').toLowerCase()}).join(',');
      if(this.makeItemsSelected.length > 0)
        url += '/make/' + this.makeItemsSelected.map((item) => {return item.replace(/ /g, '-').toLowerCase()}).join(',');
      if(this.modelItemsSelected.length > 0)
        url += '/model/' + this.modelItemsSelected.map((item) => {return item.replace(/ /g, '-').toLowerCase()}).join(',');
      if(url.length > 0)
          url += '/';
      if(this.lang == "fr_CA")
        this.urlToGo = '/recherche' + url;
      else
        this.urlToGo = '/search' + url;
    },  
    filterInventory(){
      if(this.conditionItemsSelected.length == 0
      && this.yearItemsSelected.length == 0
      && this.makeItemsSelected.length == 0
      && this.modelItemsSelected.length == 0)
      {
        this.filteredInventory = this.inventory;
        this.load();
      }
      else
      {
        this.filteredInventory = [];
        this.inventory.forEach(item => {
          var filter = true;
          if(filter && this.conditionItemsSelected.length > 0
          && this.conditionItemsSelected.indexOf(item.condition) == -1){
            filter = false
          }
          if(filter && this.yearItemsSelected.length > 0
          && this.yearItemsSelected.indexOf(item.year) == -1){
            filter = false
          }
          if(filter && this.makeItemsSelected.length > 0
          && this.makeItemsSelected.indexOf(item.make) == -1){
            filter = false
          }
          if(filter && this.modelItemsSelected.length > 0
          && this.modelItemsSelected.indexOf(item.model) == -1){
            filter = false
          }

          if(filter){
            this.filteredInventory.push(item);
          }
        })

        this.load();
      }
    },
    hideAllComponents()
    {
      this.conditionshow = false;
      this.yearshow = false;
      this.makeshow = false;
      this.modelshow = false;
    },
    hideComponents(component)
    {
      this.conditionshow = false;
      this.yearshow = false;
      this.makeshow = false;
      this.modelshow = false;
      this[component + 'show'] = true;
    },
    updateChecked(params){
      //console.log(params)
      this[params['component'] + 'ItemsSelected'] = params['checked'];
    },
    updateSelected(){
      this.filterInventory();
      this.buildUrl();
    },
    search(){
        this.updateSelected();
        if(this.urlToGo.length > 0){
            window.location.href = this.urlToGo;
            this.searchEvent();
        }
    },
    searchEvent(){
      var payload = {'event_category': 'LBX-SRP-Home', 'event_label': ' LBX-' + this.urlToGo};
      window.sendGAEvent('LBX-Search', payload);
    },
    setPivot(component)
    {
      this[component + 'Pivot'] = true;
    },
    unsetPivot(component)
    {
      this[component + 'Pivot'] = false;
    },
    load()
    {
      this.searchData = {
        conditions: [],
        years: [],
        makes: [],
        models: [],
        count: 0,
      }
      this.filteredInventory.forEach(item => {
        this.searchData.count++;
        if(this.searchData.conditions.indexOf(item.condition) == -1)
          this.searchData.conditions.push(item.condition)
        if(this.searchData.years.indexOf(item.year) == -1)
          this.searchData.years.push(item.year)
        if(this.searchData.makes.indexOf(item.make) == -1)
          this.searchData.makes.push(item.make)
        if(this.searchData.models.indexOf(item.model) == -1)
          this.searchData.models.push(item.model)
      })

      if(!this.firstSearchData){
        this.firstSearchData = this.searchData;
      }

      if(!this.conditionPivot){
       this.conditionItems = this.searchData.conditions.sort();
      }

      if(!this.yearPivot){
        this.yearItems = this.searchData.years.sort(function(a, b){return b-a})
      }

      if(!this.makePivot){
        this.makeItems = this.searchData.makes.sort();
      }

      if(!this.modelPivot){
        this.modelItems = this.searchData.models.sort();
      }

    },
  },
}
